"use strict";

exports.__esModule = true;
var _BarChart = require("./BarChart");
Object.keys(_BarChart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BarChart[key]) return;
  exports[key] = _BarChart[key];
});